export default __webpack_public_path__ + "static/media/inspection_review.3fd51e3c.svg";